import "./AdminHeader.css";
import mmLogo from '../../assets/img/admmmlogo.png';

function AdminHeader({ menuOpen, setMenuOpen, isHidden }) {
    return (
        <header id="admin-header" className={isHidden ? "hidden" : ""}>
            <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
                <span className="hamburger-icon"></span>
                <span className="hamburger-icon"></span>
                <span className="hamburger-icon"></span>
            </button>
            <img src={mmLogo} alt="Logo da MM" className="object-contain w-56 inline-block" />
        </header>
    );
}

export default AdminHeader;
